// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vhf-radio-system.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vhf-radio-system/vhf-radio-system.js';

mount([g0]);
